import { GREY_800 } from '@mnd-frontend/ui';
import { memo } from 'react';
import styled from 'styled-components';
import { useInteractionContext } from '../../context';

const LineGroup = styled.g`
  stroke: ${GREY_800};
  stroke-width: 0.5px;
  pointer-events: none;
`;

const HoverMarker = memo(({ x, y1, y2, circles, Point }: any) => (
  <LineGroup transform={`translate(${x} 0)`}>
    <line y1={y1} y2={y2} />
    {circles.map(({ cy, color }: any, i: any) => (
      <Point key={i} cy={cy} color={color} />
    ))}
  </LineGroup>
));

const HoverMarkerContainer = memo(({ data, scaleX, scaleY, mappings, Point }: any) => {
  const { hoveredTick } = useInteractionContext();
  const hovered = hoveredTick !== undefined && data[hoveredTick];

  const [y1, y2] = scaleY.range();
  return hovered ? (
    <HoverMarker
      x={scaleX(hoveredTick)}
      y1={y1}
      y2={y2}
      circles={mappings.map(({ dataKey, color }: any) => ({
        cy: scaleY(hovered[dataKey]),
        color,
      }))}
      Point={Point}
    />
  ) : null;
});

export default HoverMarkerContainer;
